import { Modal } from "../ui/modal/Modal"
import { Msg } from "../ui/modal/utils"
import { Crosswords } from "../games/crossword/Crossword"
import { useEffect, useState } from "react"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import useFetch from "../../hooks/useFetch"
import { config } from "../../config"
import { useTranslation } from "react-i18next"

export const ModalEditorCrosswords = ({
  show,
  name,
  size,
  tag,
  text,
  origenPalabras,
}) => {
  const [entries, isPendingEntries, err, setEntries] = useFetch({
    url: `${config.apiUrl}/games/crosswords/generate?tag=${tag}&size=${size}${
      origenPalabras !== "db" ? `&text=${text}` : ''
    }`,
  })

  const [pending, setPending] = useState(false)
  const [done, setDone] = useState(false)

  const abortCtrl = new AbortController()
  // eslint-disable-next-line
  useEffect(() => {
    return () => abortCtrl.abort()
    // eslint-disable-next-line
  }, [])

  const { t } = useTranslation()

  const body = () => {
    return (
      <>
        {isPendingEntries && <Msg m={t(`ui.btns.loading`) + "..."} />}
        {err && <Msg m={t(`ui.msgs.something_went_wrong`)} />}
        {entries && (
          <div className="row pt-3 pb-5">
            <Crosswords
              data={entries}
              setData={setEntries}
              size={size}
              debugMode={true}
            />
          </div>
        )}
      </>
    )
  }

  const processData = () => {
    setPending(true)

    // data
    const { url, opt } = api.games.Crosswords.Post({
      token: getCookie("jwt"),
      name,
      size,
      entries,
    })

    const options = Object.assign({ signal: abortCtrl.signal }, opt)

    fetch(url, options)
      .then((res) => {
        if (!res.ok) throw Error("could not fetch")
        return res.json()
      })
      .then((data) => {
        // console.log(data) // msg de oki doki
        setPending(false)
        setDone(true)
      })
      .catch((err) => {
        console.log(t(`ui.msgs.something_went_wrong`), err)
        if (err.name === "AbortError") return
      })
  }

  const footerModal = () => {
    const handleCancelar = () => show[1](false)

    return (
      <>
        <button
          type="button"
          onClick={handleCancelar.bind(this)}
          className="btn btn-danger">
          {t(`ui.btns.cancel`)}
        </button>
        <button
          type="button"
          disabled={pending}
          onClick={processData.bind(this)}
          className="btn btn-primary">
          {pending ? t(`ui.btns.submiting`) + "..." : t(`ui.btns.save`)}
        </button>
      </>
    )
  }

  const closeAll = () => {
    setDone(false)
    show[1](false)
  }

  return (
    <>
      <Modal
        id="editor-de-juego"
        className="biggie"
        show={show}
        header={<center>{t(`modals.modal_crossword_editor.header`)}</center>}
        body={body()}
        footer={footerModal()}
      />
      <Modal
        id="ok-nuevo-crossword"
        show={[done, setDone]}
        header={<center>{t(`ui.msgs.success`)}</center>}
        body={
          <center className="px-2 py-4">{t(`ui.msgs.successful_save`)}</center>
        }
        footer={
          <button
            type="button"
            onClick={closeAll.bind(this)}
            className="btn btn-primary">
            {t("ui.btns.ok")}
          </button>
        }
      />
    </>
  )
}
